// extracted by mini-css-extract-plugin
module.exports = {" _key":"demo/menu","root":"menu-m__root__34HPG","menuContainer":"menu-m__menuContainer__1lZUl","home":"menu-m__home__3ExrL","logo":"menu-m__logo__2cdP4"};